import { render } from "./HeroiconsSolidArrowCircleUp.vue?vue&type=template&id=df4921ce"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowCircleUp.vue"]])

export default __exports__